export default {
  props: ['course', 'coursework_listing'],
  template: '#quick_actions_panel_template',
  computed: {
    isHidden() {
      return (this.quickActions.length === 0) && _.all(this.coursework_listing, function (coursework) { return coursework.hide_due_date; });
    },
    quickActions() {
      const self = this;
      let actions = [];

      _.each(this.pendingCoursework, function (coursework) {
        if (!coursework.is_completed) {
          let description = `${coursework.type === 'Survey' ? 'survey' : 'coursework'} is ${self.getDescription(coursework.formatted_due_date)}`;
          actions.push({name: coursework.name, link_title: `View ${coursework.type === 'Survey' ? 'Survey' : I18n.t('models.coursework').toUpperCase()}`, link_path: coursework.coursework_path, description: description, due_date: coursework.formatted_due_date, class_name: (coursework.family || '').replace('Survey', 'quiz')});
        }

        if (coursework.peer_assessment_pending) {
          let description = `peer assessment is ${self.getDescription(coursework.peer_assessment_deadline)}`;
          actions.push({name: `${coursework.name}`, link_title: 'View Coursework', link_path: coursework.coursework_path, description: description, due_date: coursework.peer_assessment_deadline, class_name: (coursework.family || '').replace('Survey', 'quiz')});
        }

        if (coursework.gallery_participation_pending) {
          let description = `gallery participation is ${self.getDescription(coursework.formatted_due_date)}`;
          actions.push({name: `${coursework.name}`, link_title: 'Go to Gallery', link_path: coursework.gallery_participation_target, description: description, due_date: coursework.formatted_due_date, class_name: (coursework.family || '').replace('Survey', 'quiz')});
        }

        if (coursework.forum_participation_pending) {
          let description = `forum participation is ${self.getDescription(coursework.formatted_due_date)}`;
          actions.push({name: `${coursework.name}`, link_title: 'Go to Forum', link_path: coursework.forum_participation_target, description: description, due_date: coursework.formatted_due_date, class_name: (coursework.family || '').replace('Survey', 'quiz')});
        }
      });

      return _.sortBy(actions, function (item) {
        return (new Date(item.due_date));
      });
    },
    pendingCoursework() {
      return _.filter(this.coursework_listing, function(coursework) {
        return !coursework.hide_due_date && (!coursework.is_completed || coursework.peer_assessment_pending || coursework.participation_assessment_pending);
      });
    }
  },
  methods: {
    getDescription(date) {
      date = Kadenze.Util.getMomentDate(date);
      let time_frame = date.fromNow(true);
      return (moment().diff(date) >= 0) ? `${time_frame} over due.` : `due in ${time_frame}.`;
    }
  }
};
